export default __webpack_public_path__ + "static/Maria-e44e1ef754183f00da5a01c7d01da088.png";